import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        cardsContainer: {
            display: 'flex',
            flexWrap: 'nowrap',
            justifyContent: 'flex-start',
            gap: 'xxsmall-1.base',
            alignItems: 'stretch',
            w: '100%',
        },
        card: {
            maxW: remCalc(390),
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 'large-1',
            minW: {base: remCalc(280), sm: remCalc(280), md: remCalc(280), lg: remCalc(352)},
            minH: {
                base: remCalc(110),
                sm: remCalc(110),
                md: remCalc(110),
                lg: remCalc(139),
            },
        },
        cardText: {
            textStyle: 'normal',
            fontWeight: 'medium',
        },
    },
}
